module.exports = __webpack_public_path__ + "img/dice-1.992193d6.svg";